import { render, staticRenderFns } from "./VerCapacitacion.vue?vue&type=template&id=27bfe4b4&scoped=true"
import script from "./VerCapacitacion.vue?vue&type=script&lang=js"
export * from "./VerCapacitacion.vue?vue&type=script&lang=js"
import style0 from "./VerCapacitacion.vue?vue&type=style&index=0&id=27bfe4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bfe4b4",
  null
  
)

export default component.exports